import {Injectable} from '@angular/core';
import {MesApiService} from "common-shared";

@Injectable({
  providedIn: 'root'
})
export class AsprovaService extends MesApiService {

  constructor() {
    super('AsprovaSync', 'epl');
  }

  imeSync() {
    return this.getSingle<any>({
      action: 'Ime'
    });
  }
}
